<template>
  <section>
    <VerReporte />
    <h3>
      <v-alert :value="true" color="#007DBB" class="letras_titulo">
        <v-icon>picture_as_pdf</v-icon>
        Planilla general
      </v-alert>
    </h3>
    <v-card>
      <v-card-text class="secondary">
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-container grid-list-md class="p-0" style="min-width: 100%">
            <!--Reportes -->
            <div class="text-xs-center">
              <v-layout wrap>
                <v-flex md6 xs12>
                  <v-autocomplete
                    :items="gestiones"
                    item-value="valor"
                    item-text="valor"
                    v-model="form.gestion"
                    :rules="$validate(['required'])"
                    required
                    label="Seleccionar gestión"
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex md6 xs12>
                  <v-autocomplete
                    :items="meses"
                    item-value="id"
                    item-text="valor"
                    v-model="form.mes"
                    :rules="$validate(['required'])"
                    required
                    label="Seleccionar mes"
                    outline
                    clearable
                  />
                </v-flex>

                <v-flex md6 xs12>
                  <v-btn color="#812595" dark @click="verReporte(1)" large round>
                    Planilla general (EXCEL)
                    <v-icon>description</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex md6 xs12>
                  <v-btn color="#812595" dark @click="verReporte(2)" large round>
                    Planilla general (PDF)
                    <v-icon>picture_as_pdf</v-icon>
                  </v-btn>
                </v-flex>
            
                <v-flex md6 xs12>
                  <v-btn  color="rgba( 114, 63, 223,0.7)"  @click="verReporte(3)" round>
                    Planilla de refrigerios (EXCEL)
                    <v-icon>description</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex md6 xs12>
                  <v-btn  color="rgba( 114, 63, 223,0.7)"  @click="verReporte(4)" round>
                    Planilla de refrigerios (PDF)
                    <v-icon>picture_as_pdf</v-icon>
                  </v-btn>
                </v-flex>
                <!-- <v-flex md3 xs3>
                  <v-btn
                    :disabled="!bandera_boton_buscar"
                    color="rgba( 114, 63, 223,0.7)"
                    title="Ver planilla de refrigerios del MEFP"
                    type="submit"
                    @click.prevent="verReporte(5)"
                  >
                    <v-icon>picture_as_pdf</v-icon>
                  </v-btn>
                </v-flex> -->
                <v-flex md6 xs12>
                  <v-btn  color="rgba( 179, 3, 110 ,0.7)"  @click="verReporte(5)" round>
                    multas y sanciones F11(EXCEL)
                    <v-icon>description</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex md6 xs12>
                  <v-btn  color="rgba( 179, 3, 110 ,0.7)"  @click="verReporte(6)" round>
                    multas y sanciones F11(PDF)
                    <v-icon>picture_as_pdf</v-icon>
                  </v-btn>
                </v-flex>
                <!-- <v-flex md3 xs3>
                  <v-btn
                    :disabled="!bandera_boton_buscar"
                    color="rgba( 179, 3, 110 ,0.7)"
                    title="Ver multas y sanciones F11 del MEFP"
                    type="submit"
                    @click.prevent="verReporte(form, 3)"
                  >
                    <v-icon>picture_as_pdf</v-icon>
                  </v-btn>
                </v-flex> -->
                <v-flex md6 xs12>
                  <v-btn  color="rgba( 29, 73, 222 ,0.7)"  @click="verReporte(7)" round>
                    multas y sanciones F10(EXCEL)
                    <v-icon>description</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex md6 xs12>
                  <v-btn  color="rgba( 29, 73, 222 ,0.7)" @click="verReporte(8)" round>
                    multas y sanciones F10(PDF)
                    <v-icon>picture_as_pdf</v-icon>
                  </v-btn>
                </v-flex>
                <!-- <v-flex md3 xs3>
                  <v-btn
                    :disabled="!bandera_boton_buscar"
                    color="rgba( 29, 73, 222 ,0.7)"
                    title="Ver multas y sanciones F10 del MEFP"
                    type="submit"
                    @click.prevent="verReporte(form, 4)"
                  >
                    <v-icon>picture_as_pdf</v-icon>
                  </v-btn>
                </v-flex> -->
              </v-layout>
            </div>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </section>
</template>
  
  <script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

import VerReporte from "../asistencia/dialogs/VerReporte.vue";

export default {
  components: { VerReporte },
  mixins: [validate],
  data() {
    return {
      form: {},
      loading: false,
      fecha_desde: null,
      fecha_hasta: null,
      valid: false,
      meses: [
        { id: 1, valor: "ENERO" },
        { id: 2, valor: "FEBRERO" },
        { id: 3, valor: "MARZO" },
        { id: 4, valor: "ABRIL" },
        { id: 5, valor: "MAYO" },
        { id: 6, valor: "JUNIO" },
        { id: 7, valor: "JULIO" },
        { id: 8, valor: "AGOSTO" },
        { id: 9, valor: "SEPTIEMBRE" },
        { id: 10, valor: "OCTUBRE" },
        { id: 11, valor: "NOVIEMBRE" },
        { id: 12, valor: "DICIEMBRE" },
      ],
      gestiones: [
        { id: 3, valor: 2025 },
        { id: 3, valor: 2026 },
      ],
    };
  },
  async mounted() {
    this.form.gestion = new Date().getFullYear();
    this.form.mes = new Date().getMonth() + 1;
  },
  methods: {
    verReporte(valor) {
      if (!this.form.mes) {
        this.$message.info("Seleccione un mes");
        return;
      }
      if (!this.form.gestion) {
        this.$message.info("Seleccione una gestión");
        return;
      }
      let user = this.$storage.get("user");

      let url;
      let nombre_reporte = "";
      let nombre_carpeta = "";
      let formato_doc;
      if (valor == 1 || valor == 3 || valor == 5 || valor == 7) {
        formato_doc = "output=xlsx";
      }
      if (valor == 2 || valor == 4 || valor ==6 || valor ==8) {
        formato_doc = "output=pdf";
      }
      //let nombre_carpeta = "asistencia";
      if (valor != 1 && valor != 2) {
        nombre_carpeta = "planillas";
      }
      if (valor == 1 || valor == 2) {
        nombre_carpeta = "asistencia";
      }
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
        /{carpeta}/g,
        nombre_carpeta
      );

      let url_parametros = null;

      
      if (valor == 1 || valor == 2 ) {
        nombre_reporte = "rpt_planilla_asistencia";
      }
      if (valor == 3 || valor == 4 ) {
        nombre_reporte = "rpt_planilla_refrigerio";
      }
      if (valor == 5 || valor == 6 ) {
        nombre_reporte = "rpt_planilla_multa_sanciones_F11";
      }
      if (valor == 7 || valor == 8 ) {
        nombre_reporte = "rpt_planilla_multa_sanciones_F10";
      }
      url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;

      // URL con parametros
      if (valor == 1 || valor == 2 ) {
        url_parametros = `${url}&GESTION=${this.form.gestion}&MES=${this.form.mes}`;
      }
      if (valor != 1 && valor != 2 ) {
        url_parametros = `${url}&p_gestion=${this.form.gestion}&p_mes=${this.form.mes}`;
      }
      console.log("+++++++++++++++++++", url_parametros);

      this.$bus.$emit("openDialogVerReporte", url_parametros);
    },
  },
};
</script>
  
  <style>
.color_letras {
  color: azure;
}
.letras_titulo {
  color: azure;
  font-family: Arial, Helvetica, sans-serif;
  font: 1em sans-serif;
  background-color: rgb(40, 40, 165);
}
</style>
  


// WEBPACK FOOTER //
// src/components/admin/asistencia/ReportePlanillasGeneral.vue